import { render } from "./TemplesMobile.vue?vue&type=template&id=097af3bb&scoped=true"
import script from "./TemplesMobile.vue?vue&type=script&lang=js"
export * from "./TemplesMobile.vue?vue&type=script&lang=js"

import "./TemplesMobile.vue?vue&type=style&index=0&id=097af3bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097af3bb"]])

export default __exports__